// import { axiosInstance } from "#services/axiosInstance.js";
// import { useMutation } from "react-query";

// const usePut = (url, queryKey, params) => {
//   const { isLoading, error, mutateAsync, isSuccess } = useMutation(
//     queryKey,
//     async (data) => {
//       const finalUrl = data._customUrl || url;
//       const result = await axiosInstance({
//         method: "put",
//         url: finalUrl,
//         data: data,
//         params: params,
//       });
//       return result.data;
//     },
//     {
//       onError: (error) => {
//         console.log(error);
//       },
//     }
//   );

//   return { isLoading, error, mutateAsync, isSuccess };
// };

// export default usePut;
import { axiosInstance } from "#services/axiosInstance.js";
import { useMutation } from "react-query";

const usePut = (url, queryKey, params) => {
  const { isLoading, error, mutateAsync, isSuccess } = useMutation(
    queryKey,
    async (data = {}) => {
      const { _customUrl, ...payload } = data; //  separate dynamic URL and actual payload
      const finalUrl = _customUrl || url; //  support custom endpoint

      const result = await axiosInstance({
        method: "put",
        url: finalUrl,
        data: payload, //  only send actual data, not _customUrl
        params,
        headers: { "Content-Type": "application/json" },
      });

      return result.data;
    },
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return { isLoading, error, mutateAsync, isSuccess };
};

export default usePut;
